import { api } from './client';

export interface Emitente {
  id: number;
  cnpj: string;
  razao_social: string;
  nome_fantasia?: string;
  ie?: string;
  iest?: string;
  im?: string;
  cnae?: string;
  crt?: string;
  cep?: string;
  logradouro?: string;
  numero?: string;
  bairro?: string;
  complemento?: string;
  cmun?: string;
  xmun?: string;
  uf?: string;
  email?: string;
  email_envio_notas?: string;
  envio_email_automatico?: boolean;
  telefone?: string;
  ambiente?: 'homologacao' | 'producao';
  habilita_sefaz_direto?: boolean;
  emite_nfe?: boolean;
  emite_cte?: boolean;
  emite_ctos?: boolean;
  emite_mdfe?: boolean;
  serie_nfe?: number;
  serie_cte?: number;
  serie_ctos?: number;
  serie_mdfe?: number;
  prox_numero_nfe?: number;
  prox_numero_cte?: number;
  prox_numero_ctos?: number;
  prox_numero_mdfe?: number;
  ativo?: boolean;
}

export async function listEmitentes(): Promise<Emitente[]> {
  const { data } = await api.get<Emitente[]>('/emitentes');
  return data;
}

export async function listEmitentesAll(): Promise<Emitente[]> {
  const { data } = await api.get<Emitente[]>('/emitentes', { params: { inativos: true } });
  return data;
}

export async function getEmitente(id: number): Promise<Emitente> {
  const { data } = await api.get<Emitente>(`/emitentes/${id}`);
  return data;
}

export async function createEmitente(payload: Partial<Emitente>): Promise<Emitente> {
  const { data } = await api.post<Emitente>('/emitentes', payload);
  return data;
}

export async function updateEmitente(id: number, payload: Partial<Emitente>): Promise<Emitente> {
  const { data } = await api.put<Emitente>(`/emitentes/${id}`, payload);
  return data;
}

export interface NumeracaoItem {
  tipo: string;
  label: string;
  serie: number;
  ambiente: string;
  campo_serie: string;
  campo_proximo: keyof Emitente;
  proximo_atual: number;
  proximo_sugerido: number;
  max_consumido: number;
  max_banco: number;
  max_outros_ambientes: number;
  situacao: 'ok' | 'atrasado' | 'adiantado' | string;
  precisa_ajuste: boolean;
}

export interface NumeracaoAuditoria {
  emitente_id: number;
  ambiente: string;
  resumo: {
    total: number;
    ok: number;
    atrasados: number;
    adiantados: number;
  };
  itens: NumeracaoItem[];
}

export interface NumeracaoResync {
  emitente_id: number;
  ok: boolean;
  mudancas: Record<string, { de: number; para: number; tipo: string; serie: number; ambiente: string; max_consumido: number }>;
}

export async function auditarNumeracaoEmitente(id: number): Promise<NumeracaoAuditoria> {
  const { data } = await api.get<NumeracaoAuditoria>(`/emitentes/${id}/numeracao/auditoria`);
  return data;
}

export async function resyncNumeracaoEmitente(id: number): Promise<NumeracaoResync> {
  const { data } = await api.post<NumeracaoResync>(`/emitentes/${id}/resync-numeracao`);
  return data;
}

export async function deactivateEmitente(id: number): Promise<void> {
  await api.delete(`/emitentes/${id}`);
}
